/* DOMEMARE Artikel: Inhaltsverzeichnis, Scroll-Spy, Inline-Produkt-Embeds */
(function () {
  function slug(t) {
    return t.toLowerCase().replace(/[ä]/g, 'ae').replace(/[ö]/g, 'oe').replace(/[ü]/g, 'ue').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  function buildToc(root) {
    var prose = root.querySelector('.dm-prose');
    var toc = root.querySelector('[data-dm-toc]');
    if (!prose || !toc) return;
    var withSub = toc.getAttribute('data-dm-toc') === 'h2h3';
    var heads = prose.querySelectorAll(withSub ? 'h2, h3' : 'h2');
    if (heads.length < 2) { toc.hidden = true; return; }

    var list = toc.querySelector('ol');
    var used = {};
    heads.forEach(function (h) {
      var id = h.id || slug(h.textContent || 'abschnitt');
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'dm-toc__sub';
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });

    if (!('IntersectionObserver' in window)) return;
    var links = list.querySelectorAll('a');
    var map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (current) current.classList.remove('is-active');
          current = map[e.target.id];
          if (current) current.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
    heads.forEach(function (h) { io.observe(h); });
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{amount_with_comma_separator}}') > -1) v = v.replace('.', ',');
    return (format || '{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  function embeds(root) {
    var nodes = root.querySelectorAll('[data-dm-product]');
    if (!nodes.length) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var fmt = document.body.getAttribute('data-money-format') || '{{amount}}';
    nodes.forEach(function (node) {
      var handle = node.getAttribute('data-dm-product');
      var cta = node.getAttribute('data-dm-cta') || 'Shop now';
      var label = node.getAttribute('data-dm-label') || '';
      fetch(base + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1$2') : '';
          var url = base.replace(/\/$/, '') + '/products/' + p.handle;
          node.innerHTML =
            '<aside class="dm-embed">' +
              '<a class="dm-embed__media" href="' + url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
              '<div class="dm-embed__body">' +
                (label ? '<span class="dm-eyebrow">' + label + '</span>' : '') +
                '<h3 class="dm-embed__title"><a href="' + url + '">' + p.title + '</a></h3>' +
                '<div class="dm-embed__row"><span class="dm-embed__price">' + money(p.price, fmt) + '</span>' +
                '<a class="button button--size--sm" href="' + url + '">' + cta + '</a></div>' +
              '</div>' +
            '</aside>';
        }).catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('.dm-article').forEach(function (root) {
      buildToc(root);
      embeds(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
